// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1rrg7","inputDescription":"styles_inputDescription__1nUWk"};